module.exports = __webpack_public_path__ + "media/images/new/icons/rss-be50684bda0c8f7c5ac99ce10815ae11.png";